/** The form/assignment title style. Shared so edit, preview and fill pages cannot drift apart. */
export const FORM_TITLE_CLASS =
	'font-basier-square text-4xl font-medium leading-snug tracking-tight md:text-[44px]';
